<mg-icon
  class="tooltip"
  matTooltipClass="tooltip-text"
  [matTooltip]="label"
  [ngClass]="tooltipStyleClasses"
  (click)="toggle()"
  [iconName]="icon">
</mg-icon>
